export default "__VITE_ASSET__O4q3Wv2R__"